module.exports = __webpack_public_path__ + "img/appalachian-college-of-pharmacy-logo.7f2d384d.png";